export enum EmailHistoryModule {
  PurchaseOrders = 'purchase_orders',
  SalesOrders = 'sales_orders',
  References = 'references',
  Users = 'users',
  Auth = 'auth',
}
